//@ts-nocheck
import Swiper from "swiper";
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';
const contentSliders = () => {
	const sections = document.querySelectorAll(".js-content-slider-section");
	if (sections.length === 0) return;

	sections.forEach((section) => {
		const slider = section.querySelector(".js-content-slider");
		const sliderBtnNext = section.querySelector(
			".js-content-slider-btn-next"
		);
		const sliderBtnPrev = section.querySelector(
			".js-content-slider-btn-prev"
		);

		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			loop: true,
			modules: [Navigation, Autoplay, EffectFade],
			effect: "fade",
            speed: 300,
			fadeEffect: {
				crossFade: true,
			},
			autoplay: {
				delay: 8000,
			},
			navigation: {
				prevEl: sliderBtnPrev,
				nextEl: sliderBtnNext,
			},
		});
	});
};

export default contentSliders;